import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { FAB_SURGE_GET_USER_LIST, FAB_SURGE_GET_USER_LIST_ERROR, FAB_SURGE_GET_USER_LIST_SUCCESS } from '../../../actions.js';

function* getFabUserList({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/get-card-details/user_management`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: FAB_SURGE_GET_USER_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: FAB_SURGE_GET_USER_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: FAB_SURGE_GET_USER_LIST_ERROR, payload: error });
  }
}

export function* watchGetFabUserList() {
  yield takeEvery(FAB_SURGE_GET_USER_LIST, getFabUserList);
}

function* getFabUserListSaga() {
  yield all([fork(watchGetFabUserList)]);
}

export default getFabUserListSaga;
